import ContactCard from "./ContactCard";

export default ContactCard;
